import api from '../services/api';
import endpoints, { publicEndpoints } from './commonVariables/endpoints';
import { decodeUrlForm } from './encodeFormUrl';

//local storage
export const tokenKey = 'TOKEN';
export var lsToken = localStorage.getItem(tokenKey);

export const webTokenKey = 'SRT';
export const webToken = localStorage.getItem(webTokenKey);

export const rolKey = 'ROL';
export var rol = localStorage.getItem(rolKey);

export const sidKey = 'SID';
export var IdSystemUser = localStorage.getItem(sidKey);

export const IdHotelOwnerKey = 'IdHotelOwner';
export var IdHotelOwner = localStorage.getItem(IdHotelOwnerKey);

export const usernameKey = 'Username';
export const username = localStorage.getItem(usernameKey);

export const HotelInfoKey = 'hotelInfo';

const tokenProdKey = 'tokenProd';
export var tokenProd = localStorage.getItem(tokenProdKey);

export const cacheKey = 'cache';

export const lastPageVisitedKey = 'lastPageVisited';

export const defaultLanguage = 'en';
export const customLanguages = ['es', 'fr', 'de'];
export const appLanguages = [defaultLanguage, ...customLanguages];
export const lsLanguageKey = 'language';
export const lsLanguage = localStorage.getItem(lsLanguageKey);
export const defaultTimezone = 'Europe/Madrid';
export const authorizedUsers = ['HOTELOWNER'];

///// functions
export const isAuthorizedRol = roles => {
    const arrayRoles = roles.split(',');
    return arrayRoles.some(_rol => authorizedUsers.includes(_rol));
};

export const logIn = async logInData => {
    const { data } = await api.post(publicEndpoints.login, logInData);
    const { roles, sid, extendedRoles } = data;
    // estended roles string structure => EXTENDED_ROLE | ID_ENTITY , EXTENDED_ROLE | ID_ENTITY ...
    // ex:  "extendedRoles": "HotelOwner|1234,Agency|1234", => normally only hotelOwner role
    const extendedRolesArray = extendedRoles
        .split(',')
        .map(_rol => _rol.split('|'));
    const ownerExtendedRole = extendedRolesArray.find(
        ([extendedRole, _idEntity]) => {
            return extendedRole.toLowerCase() === 'hotelowner';
        }
    );
    if (isAuthorizedRol(roles) && ownerExtendedRole) {
        const [, _idHotelOwner] = ownerExtendedRole;

        localStorage.setItem(tokenKey, data.access_token);
        localStorage.setItem(rolKey, data.roles);
        localStorage.setItem(sidKey, sid);
        localStorage.setItem(IdHotelOwnerKey, _idHotelOwner);
        localStorage.setItem(webTokenKey, data.webtoken);
        const decodedLogInData = decodeUrlForm(logInData);
        if (decodedLogInData?.username)
            localStorage.setItem(usernameKey, decodedLogInData?.username);
        return true;
    } else {
        return false;
    }
};

export const logOut = () => {
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(webTokenKey);
    localStorage.removeItem(rolKey);
    localStorage.removeItem(sidKey);
    localStorage.removeItem(IdHotelOwnerKey);
    localStorage.removeItem(HotelInfoKey);
    localStorage.removeItem(usernameKey);

    const lastPageVisited = localStorage.getItem(lastPageVisitedKey);
    localStorage.setItem(lastPageVisitedKey, lastPageVisited);
};

export const getAreLocalStorageUserData = () => {
    return (
        lsToken && rol && IdSystemUser && IdHotelOwner && webToken && username
    );
};

export const checkCredentials = async () => {
    let isValidToken = null;
    try {
        const { data } = await api.get(endpoints.checkCredentials);
        isValidToken = data.Result;
    } catch {
        isValidToken = false;
    }
    return isValidToken;
};

export const getInitialLang = () => {
    const navigatorLanguage = navigator.language || navigator.userLanguage;
    const langCode = (lsLanguage || navigatorLanguage).slice(0, 2);
    if (customLanguages.includes(langCode)) return langCode;
    return defaultLanguage;
};
